import React, {useRef, useState} from 'react';
import {Animated, Easing, StyleSheet} from 'react-native';
import { ThemedPressable, ThemedText, ThemedView } from '@app/theme';
import { CaretDown } from '@app/sharedComponents/Icons';

const AccordionListItem = ({ title, children, subTitle,subTitleColor='text-primary'}) => {
    const [open, setOpen] = useState(false);
    const animatedController = useRef(new Animated.Value(0)).current;
    const [bodySectionHeight, setBodySectionHeight] = useState<number>(0);

    const bodyHeight = animatedController.interpolate({
        inputRange: [0, 1],
        outputRange: [0, bodySectionHeight],
    });

    const arrowAngle = animatedController.interpolate({
        inputRange: [0, 1],
        outputRange: ['0rad', `${Math.PI}rad`],
    });

    const toggleListItem = () => {
        if (open) {
            Animated.timing(animatedController, {
                useNativeDriver: false,
                duration: 300,
                toValue: 0,
                easing: Easing.bezier(0.4, 0.0, 0.2, 1)
            }).start();
        } else {
            Animated.timing(animatedController, {
                useNativeDriver: false,
                duration: 300,
                toValue: 1,
                easing: Easing.bezier(0.4, 0.0, 0.2, 1)
            }).start();
        }
        setOpen(!open);
    };

    // Need to add color to the text on dynamic basis
    return (
        <ThemedView mt="lg">
            <ThemedPressable onPress={() => toggleListItem()}>
                <ThemedView px='lg' flexDirection='row' justifyContent='space-between' alignItems='center'>
                    <ThemedView flexDirection='row' alignItems='center'>
                        <ThemedText variant='b4s' color='text-primary' >{title}</ThemedText>
                        <Animated.View style={{ transform: [{ rotateZ: arrowAngle }] , marginLeft: 8,justifyContent:'center',alignItems:'center' }}>
                            <CaretDown size="16" />
                        </Animated.View>
                    </ThemedView>
                    <ThemedText variant='b4s' color={subTitleColor} >{subTitle}</ThemedText>
                </ThemedView>
            </ThemedPressable>
            <Animated.View style={[styles.bodyBackground, { height: bodyHeight || 0 }]}>
                <ThemedView
                    style={styles.bodyContainer}
                    onLayout={event =>
                        setBodySectionHeight(event.nativeEvent.layout.height)
                    }>
                    {children}
                </ThemedView>
            </Animated.View>
        </ThemedView>
    );
};

export default AccordionListItem;

const styles = StyleSheet.create({
    bodyBackground: {
        overflow: 'hidden',
    },
    titleOpenContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingBottom: 4,
        paddingHorizontal: 16,
        justifyContent: 'space-between',
    },
    titleContainerWithoutDivider:{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingBottom: 16,
        paddingHorizontal: 16,
        justifyContent: 'space-between',
    },
    bodyContainer: {
        position: 'absolute',
        bottom: 0,
        width : '100%'
    },
});
